




























import { Vue, Component, Prop } from 'vue-property-decorator'
import { Post } from '~base/common/types'

import Spinner from '~components/utils/Spinner.vue'
import CloseHandle from '~components/content/widgets/CloseHandle.vue'
import BreadCrumbs from '~components/content/widgets/BreadCrumbs.vue'
import RelatedPosts from '~components/content/widgets/RelatedPosts.vue'
import SocialBookmarks from '~components/content/widgets/SocialBookmarks.vue'
import TagsList from '~components/content/widgets/TagsList.vue'

@Component({
  components: {
    Spinner,
    CloseHandle,
    BreadCrumbs,
    RelatedPosts,
    SocialBookmarks,
    TagsList,
  },
})
export default class ArticleFooter extends Vue {
  @Prop({ type: Object }) readonly post!: Post
  @Prop({ type: Boolean, default: false }) readonly isFree!: boolean
  @Prop({ type: String, default: '' }) readonly categoryClasses!: string

  get isUsingInlinePaywall() {
    return (
      !this.$store.getters['paywall/displayMode'] ||
      this.$store.getters['paywall/displayMode'] === 'inline'
    )
  }

  get inPreviewContext() {
    return this.$store.getters['news/inPreviewContext']
  }

  get isNotShowingOffer() {
    return !this.inPreviewContext
      ? !this.$store.getters['paywall/showOfferContainer']
      : true
  }

  get showInternalForm() {
    return (
      !this.inPreviewContext && this.$store.getters['paywall/showInternalForm']
    )
  }
}
